<!--
 * @Description: 返回列表
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-05-25 18:29:05
 * @LastEditors: JDY
-->
<template>
  <a-button @click="goback" icon="arrow-left">
    返回列表
  </a-button>
</template>

<script>
export default {
  name: 'GoBack',
  props: {
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {}
  },
  methods: {
    goback () {
        // console.log(this.$route.path)
        this.$router.go(-1)
    }
  }
}
</script>

<style>

</style>
